import { onMounted, onBeforeUnmount, watch } from 'vue'
import { createMap } from '@/tools/create-map'
import { isDesktop } from '@/tools/isDesctop'
import { useCitiesStore } from '@/state/cities'
import { useUnitsStore } from '@/state/units'
import ActiveMarker from '@/assets/images/marker-active.svg'
import { useSettingsStore } from '@/state/settings'
import { MAP_NS } from '@/static-data/map'

const SPB_ID = 1

export const useCreateMap = (props: Record<string, any>) => {
  const settingsStore = useSettingsStore()
  const citiesStore = useCitiesStore()
  const unitsStore = useUnitsStore()
  const mapHeight = isDesktop() ? '100%' : '400px'
  let myMap

  let iconImageHref =
    props.settings?.iconImageHref || 'data:image/svg+xml;base64,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'

  const markerIcon = {
    layout: "default#image",
    iconImageHref, // todo refactor
    iconLayout: 'default#image',
    iconImageSize: props.settings?.iconImageSize || [30, 42],
    iconImageOffset: [-5, -38]
  }

  const checkUnitsIsShowOnMap = () => {
    const bounds = myMap.getBounds()

    unitsStore.units.forEach((unit) => {
      unit.isShowOnMap = window[MAP_NS].util.bounds.containsPoint(bounds, [unit.latitude, unit.longitude])
    })
  }

  const renderMap = async () => {
    let mapCenter
    let zoom = SPB_ID === citiesStore.currentCity?.id ? 10 : 10

    if (unitsStore.selectedUnit.id) {
      mapCenter = [unitsStore.selectedUnit.latitude, unitsStore.selectedUnit.longitude]
      zoom = 14
    }

    if (!unitsStore.selectedUnit.id) {
      mapCenter = [citiesStore.currentCity.widget_map_latitude, citiesStore.currentCity.widget_map_longitude]
    }

    myMap = new window[MAP_NS].Map('pl-map-test-test', {
      center: mapCenter,
      zoom,
      controls: []
    }, {
      searchControlProvider: 'yandex#search'
    })

    if (!isDesktop()) {
      myMap.behaviors.disable(['drag']);
    }

    if (settingsStore.settings?.map?.filter) {
      document.getElementsByClassName('ymaps-2-1-79-ground-pane')[0].style['filter'] = settingsStore.settings?.map?.filter
    }

    myMap.events.add('boundschange', async () => checkUnitsIsShowOnMap())

    checkUnitsIsShowOnMap()

    addPlaceMark()
  }

  const addPlaceMark = () => {
    unitsStore.units.forEach((unit) => {
      const myPlacemark = new window[MAP_NS].Placemark([unit.latitude, unit.longitude],
        {},
        {
          ...markerIcon,
          iconImageHref: (unitsStore.selectedUnit.id === unit.id && !props.settings?.noActiveIcon) ? ActiveMarker : iconImageHref,
          unitId: unit.id,
          address: unit.address.toLowerCase(),
          name: unit.name.toLowerCase()
        }
      )

      myPlacemark.events.add(['click'], () => unitsStore.setSelectedUnit(unit))
      myMap.geoObjects.add(myPlacemark)
    })
  }

  watch(
    () => unitsStore.selectedUnit,
    (newValue) => {
      if (!myMap) {
        return
      }

      myMap.geoObjects.each((geoObject) => {
        if (geoObject.options.get('unitId') === newValue.id) {
          if (!props.settings?.noActiveIcon) {
            geoObject.options.set('iconImageHref', ActiveMarker)
          }
        } else {
          geoObject.options.set('iconImageHref', iconImageHref)
        }
      })

      if (Object.keys(newValue).length) {
        myMap.setZoom(16)
        myMap.setCenter([newValue.latitude, newValue.longitude])
      }
    }
  )

  onMounted(async () => {
    if (window) {
      createMap(renderMap)
    }
  })

  onBeforeUnmount(() => {
    if (myMap) {
      myMap.destroy()
    }
  })

  return {
    mapHeight
  }
}
